import {Plugins, Component} from '@packages/systems/wfdl';
import {qualify} from '@packages/systems/wfdl-Qualified';

import {
  EElement,
  EText,
  ERecord,
  EBoolean,
  EEnum,
  EList,
} from '@packages/systems/wfdl-ast';

import {images} from '../constants';

export const LayoutFeaturesTable = {
  factory: EElement({
    id: '9e508438-a973-ca5d-8776-88ea2bc0ff41',
    type: qualify(Plugins.name('Layout'), Component.name('Section')),
    data: ERecord({
      grid: ERecord({
        type: EText('section'),
      }),
      tag: EEnum('section'),
      styleBlockIds: EList([EText('2e934399-08ef-eb36-b213-cacb7b4d4290')]),
      children: EList([
        EElement({
          id: '5f0d8453-8a9b-51d4-926f-1e560de30029',
          type: qualify(Plugins.name('Basic'), Component.name('Block')),
          data: ERecord({
            tag: EEnum('div'),
            text: EBoolean(false),
            styleBlockIds: EList([
              EText('81b59867-fdee-430e-3436-1014d50622b3'),
            ]),
            children: EList([
              EElement({
                id: '4f2e85c2-f236-0116-6616-24d2a749e8b5',
                type: qualify(Plugins.name('Basic'), Component.name('Heading')),
                data: ERecord({
                  tag: EEnum('h2'),
                  styleBlockIds: EList([
                    EText('9d78c9f2-a6ff-000f-04de-5c8b5b2ce3a4'),
                  ]),
                  children: EList([
                    EElement({
                      id: '4f2e85c2-f236-0116-6616-24d2a749e8b6',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('String')
                      ),
                      data: EText('Comparison table section'),
                    }),
                  ]),
                }),
              }),
              EElement({
                id: '618fa776-1be9-7c91-a330-36fdda8a1ac8',
                type: qualify(
                  Plugins.name('Basic'),
                  Component.name('Paragraph')
                ),
                data: ERecord({
                  styleBlockIds: EList([
                    EText('e8e462ae-eca2-3d8e-55fa-0d15b916d1ba'),
                  ]),
                  children: EList([
                    EElement({
                      id: '618fa776-1be9-7c91-a330-36fdda8a1ac9',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('String')
                      ),
                      data: EText(
                        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse tincidunt sagittis eros. Quisque quis euismod lorem.'
                      ),
                    }),
                  ]),
                }),
              }),
              EElement({
                id: '806be11e-6f37-984b-db94-fd424f7cb51f',
                type: qualify(Plugins.name('Basic'), Component.name('Block')),
                data: ERecord({
                  tag: EEnum('div'),
                  text: EBoolean(false),
                  styleBlockIds: EList([
                    EText('da663c1e-b0ab-9b88-45c2-6595000445a6'),
                  ]),
                  children: EList([
                    EElement({
                      id: 'a59f2909-49a0-2ae5-2b78-f072314d1377',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Block')
                      ),
                      data: ERecord({
                        tag: EEnum('div'),
                        text: EBoolean(false),
                        styleBlockIds: EList([
                          EText('05992751-db89-cbf1-a7e5-d2e95aab82e5'),
                        ]),
                        children: EList([
                          EElement({
                            id: '30445fd0-8913-bee0-82fe-a5ee5c90e7ad',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Heading')
                            ),
                            data: ERecord({
                              tag: EEnum('h3'),
                              styleBlockIds: EList([
                                EText('6de39325-6540-b9db-9d70-d0a0c1390135'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '30445fd0-8913-bee0-82fe-a5ee5c90e7ae',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText('Lorem ipsum dolor'),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '017f44e3-d88a-9c88-8837-694d6756fc04',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Heading')
                            ),
                            data: ERecord({
                              tag: EEnum('h3'),
                              styleBlockIds: EList([
                                EText('6de39325-6540-b9db-9d70-d0a0c1390135'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '017f44e3-d88a-9c88-8837-694d6756fc05',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText('Unde omnis iste'),
                                }),
                              ]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                    EElement({
                      id: '14405fc8-a1b6-d8b0-4b12-4963172b5e41',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Block')
                      ),
                      data: ERecord({
                        tag: EEnum('div'),
                        text: EBoolean(false),
                        styleBlockIds: EList([
                          EText('7b92fdac-2e10-090f-77a2-d78704c145ba'),
                        ]),
                        children: EList([
                          EElement({
                            id: '14405fc8-a1b6-d8b0-4b12-4963172b5e42',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              tag: EEnum('div'),
                              text: EBoolean(true),
                              style: ERecord({
                                base: ERecord({
                                  main: ERecord({
                                    noPseudo: ERecord({
                                      gridColumnStart: EText('span 1'),
                                      gridColumnEnd: EText('span 1'),
                                      gridRowStart: EText('span 1'),
                                      gridRowEnd: EText('span 1'),
                                    }),
                                  }),
                                }),
                              }),
                              styleBlockIds: EList([
                                EText('0cd8c695-5c6c-33d7-e259-34b9ee75f46d'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '14405fc8-a1b6-d8b0-4b12-4963172b5e43',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText(
                                    'Etiam sodales ac felis id interdum'
                                  ),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '14405fc8-a1b6-d8b0-4b12-4963172b5e44',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              tag: EEnum('div'),
                              text: EBoolean(true),
                              style: ERecord({
                                base: ERecord({
                                  main: ERecord({
                                    noPseudo: ERecord({
                                      gridColumnStart: EText('span 1'),
                                      gridColumnEnd: EText('span 1'),
                                      gridRowStart: EText('span 1'),
                                      gridRowEnd: EText('span 1'),
                                    }),
                                  }),
                                }),
                              }),
                              styleBlockIds: EList([
                                EText('c66ebd62-532f-3d66-0221-2b6c424df224'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '14405fc8-a1b6-d8b0-4b12-4963172b5e45',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText(
                                    'Etiam sodales ac felis id interdum'
                                  ),
                                }),
                              ]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                    EElement({
                      id: '5042623e-5fbd-5831-6523-b8458edf6eb5',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Block')
                      ),
                      data: ERecord({
                        tag: EEnum('div'),
                        text: EBoolean(false),
                        styleBlockIds: EList([
                          EText('7b92fdac-2e10-090f-77a2-d78704c145ba'),
                        ]),
                        children: EList([
                          EElement({
                            id: '5042623e-5fbd-5831-6523-b8458edf6eb6',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              tag: EEnum('div'),
                              text: EBoolean(true),
                              style: ERecord({
                                base: ERecord({
                                  main: ERecord({
                                    noPseudo: ERecord({
                                      gridColumnStart: EText('span 1'),
                                      gridColumnEnd: EText('span 1'),
                                      gridRowStart: EText('span 1'),
                                      gridRowEnd: EText('span 1'),
                                    }),
                                  }),
                                }),
                              }),
                              styleBlockIds: EList([
                                EText('0cd8c695-5c6c-33d7-e259-34b9ee75f46d'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '5042623e-5fbd-5831-6523-b8458edf6eb7',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText(
                                    'Etiam sodales ac felis id interdum'
                                  ),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '5042623e-5fbd-5831-6523-b8458edf6eb8',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              tag: EEnum('div'),
                              text: EBoolean(true),
                              style: ERecord({
                                base: ERecord({
                                  main: ERecord({
                                    noPseudo: ERecord({
                                      gridColumnStart: EText('span 1'),
                                      gridColumnEnd: EText('span 1'),
                                      gridRowStart: EText('span 1'),
                                      gridRowEnd: EText('span 1'),
                                    }),
                                  }),
                                }),
                              }),
                              styleBlockIds: EList([
                                EText('c66ebd62-532f-3d66-0221-2b6c424df224'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '5042623e-5fbd-5831-6523-b8458edf6eb9',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText(
                                    'Etiam sodales ac felis id interdum'
                                  ),
                                }),
                              ]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                    EElement({
                      id: '42bf1e97-4645-faaf-5c1b-c1c0e22c7fe6',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Block')
                      ),
                      data: ERecord({
                        tag: EEnum('div'),
                        text: EBoolean(false),
                        styleBlockIds: EList([
                          EText('7b92fdac-2e10-090f-77a2-d78704c145ba'),
                        ]),
                        children: EList([
                          EElement({
                            id: '42bf1e97-4645-faaf-5c1b-c1c0e22c7fe7',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              tag: EEnum('div'),
                              text: EBoolean(true),
                              style: ERecord({
                                base: ERecord({
                                  main: ERecord({
                                    noPseudo: ERecord({
                                      gridColumnStart: EText('span 1'),
                                      gridColumnEnd: EText('span 1'),
                                      gridRowStart: EText('span 1'),
                                      gridRowEnd: EText('span 1'),
                                    }),
                                  }),
                                }),
                              }),
                              styleBlockIds: EList([
                                EText('0cd8c695-5c6c-33d7-e259-34b9ee75f46d'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '42bf1e97-4645-faaf-5c1b-c1c0e22c7fe8',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText(
                                    'Etiam sodales ac felis id interdum'
                                  ),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '42bf1e97-4645-faaf-5c1b-c1c0e22c7fe9',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              tag: EEnum('div'),
                              text: EBoolean(true),
                              style: ERecord({
                                base: ERecord({
                                  main: ERecord({
                                    noPseudo: ERecord({
                                      gridColumnStart: EText('span 1'),
                                      gridColumnEnd: EText('span 1'),
                                      gridRowStart: EText('span 1'),
                                      gridRowEnd: EText('span 1'),
                                    }),
                                  }),
                                }),
                              }),
                              styleBlockIds: EList([
                                EText('c66ebd62-532f-3d66-0221-2b6c424df224'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '42bf1e97-4645-faaf-5c1b-c1c0e22c7fea',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText(
                                    'Etiam sodales ac felis id interdum'
                                  ),
                                }),
                              ]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                    EElement({
                      id: '37e2acff-fddf-0db7-d4c7-985f9439beb1',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Block')
                      ),
                      data: ERecord({
                        tag: EEnum('div'),
                        text: EBoolean(false),
                        styleBlockIds: EList([
                          EText('7b92fdac-2e10-090f-77a2-d78704c145ba'),
                        ]),
                        children: EList([
                          EElement({
                            id: '37e2acff-fddf-0db7-d4c7-985f9439beb2',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              tag: EEnum('div'),
                              text: EBoolean(true),
                              style: ERecord({
                                base: ERecord({
                                  main: ERecord({
                                    noPseudo: ERecord({
                                      gridColumnStart: EText('span 1'),
                                      gridColumnEnd: EText('span 1'),
                                      gridRowStart: EText('span 1'),
                                      gridRowEnd: EText('span 1'),
                                    }),
                                  }),
                                }),
                              }),
                              styleBlockIds: EList([
                                EText('0cd8c695-5c6c-33d7-e259-34b9ee75f46d'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '37e2acff-fddf-0db7-d4c7-985f9439beb3',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText(
                                    'Etiam sodales ac felis id interdum'
                                  ),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '37e2acff-fddf-0db7-d4c7-985f9439beb4',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              tag: EEnum('div'),
                              text: EBoolean(true),
                              style: ERecord({
                                base: ERecord({
                                  main: ERecord({
                                    noPseudo: ERecord({
                                      gridColumnStart: EText('span 1'),
                                      gridColumnEnd: EText('span 1'),
                                      gridRowStart: EText('span 1'),
                                      gridRowEnd: EText('span 1'),
                                    }),
                                  }),
                                }),
                              }),
                              styleBlockIds: EList([
                                EText('c66ebd62-532f-3d66-0221-2b6c424df224'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '37e2acff-fddf-0db7-d4c7-985f9439beb5',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText(
                                    'Etiam sodales ac felis id interdum'
                                  ),
                                }),
                              ]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                    EElement({
                      id: 'fbf1c1fe-cc53-d6dc-b24d-1b73a180ae12',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Block')
                      ),
                      data: ERecord({
                        tag: EEnum('div'),
                        text: EBoolean(false),
                        styleBlockIds: EList([
                          EText('7b92fdac-2e10-090f-77a2-d78704c145ba'),
                        ]),
                        children: EList([
                          EElement({
                            id: 'fbf1c1fe-cc53-d6dc-b24d-1b73a180ae13',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              tag: EEnum('div'),
                              text: EBoolean(true),
                              style: ERecord({
                                base: ERecord({
                                  main: ERecord({
                                    noPseudo: ERecord({
                                      gridColumnStart: EText('span 1'),
                                      gridColumnEnd: EText('span 1'),
                                      gridRowStart: EText('span 1'),
                                      gridRowEnd: EText('span 1'),
                                    }),
                                  }),
                                }),
                              }),
                              styleBlockIds: EList([
                                EText('0cd8c695-5c6c-33d7-e259-34b9ee75f46d'),
                              ]),
                              children: EList([
                                EElement({
                                  id: 'fbf1c1fe-cc53-d6dc-b24d-1b73a180ae14',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText(
                                    'Etiam sodales ac felis id interdum'
                                  ),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: 'fbf1c1fe-cc53-d6dc-b24d-1b73a180ae15',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              tag: EEnum('div'),
                              text: EBoolean(true),
                              style: ERecord({
                                base: ERecord({
                                  main: ERecord({
                                    noPseudo: ERecord({
                                      gridColumnStart: EText('span 1'),
                                      gridColumnEnd: EText('span 1'),
                                      gridRowStart: EText('span 1'),
                                      gridRowEnd: EText('span 1'),
                                    }),
                                  }),
                                }),
                              }),
                              styleBlockIds: EList([
                                EText('c66ebd62-532f-3d66-0221-2b6c424df224'),
                              ]),
                              children: EList([
                                EElement({
                                  id: 'fbf1c1fe-cc53-d6dc-b24d-1b73a180ae16',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText(
                                    'Etiam sodales ac felis id interdum'
                                  ),
                                }),
                              ]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                    EElement({
                      id: '3529da81-884e-59e2-3600-9b8d684204ea',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Block')
                      ),
                      data: ERecord({
                        tag: EEnum('div'),
                        text: EBoolean(false),
                        styleBlockIds: EList([
                          EText('7b92fdac-2e10-090f-77a2-d78704c145ba'),
                        ]),
                        children: EList([
                          EElement({
                            id: '3529da81-884e-59e2-3600-9b8d684204eb',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              tag: EEnum('div'),
                              text: EBoolean(true),
                              style: ERecord({
                                base: ERecord({
                                  main: ERecord({
                                    noPseudo: ERecord({
                                      gridColumnStart: EText('span 1'),
                                      gridColumnEnd: EText('span 1'),
                                      gridRowStart: EText('span 1'),
                                      gridRowEnd: EText('span 1'),
                                    }),
                                  }),
                                }),
                              }),
                              styleBlockIds: EList([
                                EText('0cd8c695-5c6c-33d7-e259-34b9ee75f46d'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '3529da81-884e-59e2-3600-9b8d684204ec',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText(
                                    'Etiam sodales ac felis id interdum'
                                  ),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '3529da81-884e-59e2-3600-9b8d684204ed',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              tag: EEnum('div'),
                              text: EBoolean(true),
                              style: ERecord({
                                base: ERecord({
                                  main: ERecord({
                                    noPseudo: ERecord({
                                      gridColumnStart: EText('span 1'),
                                      gridColumnEnd: EText('span 1'),
                                      gridRowStart: EText('span 1'),
                                      gridRowEnd: EText('span 1'),
                                    }),
                                  }),
                                }),
                              }),
                              styleBlockIds: EList([
                                EText('c66ebd62-532f-3d66-0221-2b6c424df224'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '3529da81-884e-59e2-3600-9b8d684204ee',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText(
                                    'Etiam sodales ac felis id interdum'
                                  ),
                                }),
                              ]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                  ]),
                }),
              }),
            ]),
          }),
        }),
      ]),
    }),
  }),
  styleBlocks: [
    {
      _id: '2e934399-08ef-eb36-b213-cacb7b4d4290',
      type: 'class',
      name: 'Features Table',
      comb: '',
      styleLess:
        'position: relative; padding-top: 80px; padding-right: 30px; padding-bottom: 80px; padding-left: 30px; border-bottom-style: solid; border-bottom-width: 1px; border-bottom-color: hsla(212.00000000000006, 38.46%, 92.35%, 1.00);',
      children: [],
      variants: {
        small: {
          styleLess:
            'padding-top: 60px; padding-right: 15px; padding-bottom: 60px; padding-left: 15px;',
        },
      },
    },
    {
      _id: '81b59867-fdee-430e-3436-1014d50622b3',
      type: 'class',
      name: 'Container',
      comb: '',
      styleLess:
        'width: 100%; max-width: 940px; margin-right: auto; margin-left: auto;',
      children: [],
      variants: {
        medium: {styleLess: 'max-width: 728px;'},
        tiny: {styleLess: 'max-width: none;'},
      },
    },
    {
      _id: '9d78c9f2-a6ff-000f-04de-5c8b5b2ce3a4',
      type: 'class',
      name: 'Centered Heading',
      comb: '',
      styleLess: 'margin-bottom: 16px; text-align: center;',
      children: ['d857c47f-13ef-6c7e-7f97-30e5beebeba3'],
      variants: {tiny: {styleLess: 'margin-bottom: 24px;'}},
    },
    {
      _id: 'e8e462ae-eca2-3d8e-55fa-0d15b916d1ba',
      type: 'class',
      name: 'Centered Subheading',
      comb: '',
      styleLess:
        'max-width: 530px; margin-right: auto; margin-left: auto; text-align: center;',
      children: [],
      variants: {},
    },
    {
      _id: 'da663c1e-b0ab-9b88-45c2-6595000445a6',
      type: 'class',
      name: 'Comparison Table',
      comb: '',
      styleLess: 'display: flex; margin-top: 50px; flex-direction: column;',
      children: [],
      variants: {},
    },
    {
      _id: '05992751-db89-cbf1-a7e5-d2e95aab82e5',
      type: 'class',
      name: 'Comparison Row Main',
      comb: '',
      styleLess:
        'display: grid; padding-top: 24px; padding-bottom: 24px; grid-auto-columns: 1fr; grid-column-gap: 0px; grid-row-gap: 0px; grid-template-columns: 1fr 1fr; grid-template-rows: auto; border-bottom-style: solid; border-bottom-width: 1px; border-bottom-color: hsla(212.00000000000006, 38.46%, 92.35%, 1.00); background-color: hsla(216, 33.33%, 97.06%, 1.00);',
      children: [],
      variants: {tiny: {styleLess: 'grid-column-gap: 20px;'}},
    },
    {
      _id: '6de39325-6540-b9db-9d70-d0a0c1390135',
      type: 'class',
      name: 'Comparison Title',
      comb: '',
      styleLess: 'margin-bottom: 0px; margin-left: 24px;',
      children: [],
      variants: {tiny: {styleLess: 'margin-left: 10px;'}},
    },
    {
      _id: '7b92fdac-2e10-090f-77a2-d78704c145ba',
      type: 'class',
      name: 'Comparison Row',
      comb: '',
      styleLess:
        'display: grid; padding-top: 24px; padding-bottom: 24px; grid-auto-columns: 1fr; grid-column-gap: 0px; grid-row-gap: 0px; grid-template-columns: 1fr 1fr; grid-template-rows: auto; border-bottom-style: solid; border-bottom-width: 1px; border-bottom-color: hsla(212.00000000000006, 38.46%, 92.35%, 1.00);',
      children: [],
      variants: {tiny: {styleLess: 'grid-column-gap: 20px;'}},
    },
    {
      _id: '0cd8c695-5c6c-33d7-e259-34b9ee75f46d',
      type: 'class',
      name: 'Comparison Negative',
      comb: '',
      styleLess: `margin-left: 24px; padding-left: 40px; background-image: url(${images.plusRotatedDark}); background-position: 0% 50%; background-size: auto; background-repeat: no-repeat;`,
      children: [],
      variants: {
        tiny: {
          styleLess:
            'margin-left: 10px; padding-left: 20px; background-position: 0px 5px; background-size: 14px;',
        },
      },
    },
    {
      _id: 'c66ebd62-532f-3d66-0221-2b6c424df224',
      type: 'class',
      name: 'Comparison Positive',
      comb: '',
      styleLess: `margin-left: 24px; padding-left: 40px; background-image: url(${images.checkCircleDark}); background-position: 0% 50%; background-size: auto; background-repeat: no-repeat;`,
      children: [],
      variants: {
        tiny: {
          styleLess:
            'margin-left: 10px; padding-left: 20px; background-position: 0px 4px; background-size: 16px;',
        },
      },
    },
  ],
} as const;
